import styled, { css } from 'styled-components';
import { layout, media } from 'src/components/base';
import ListOfExpertsComponent from '../../../expert/components/list-of-experts';
import ContentCardsComponent from '../../../expert/components/list-of-content-cards';
import { Button } from '@prisjakt/ui/button';

export const ExpertSection = styled.div`
  display: grid;
  grid-template-rows: 1fr auto;
  row-gap: ${layout.measurements.spacing150};
  margin-top: ${layout.measurements.spacing100};
`;

export const Section = styled.div`
  display: grid;
  grid-template-columns: 50% auto ${layout.measurements.spacing050};
  column-gap: ${layout.measurements.spacing100};

  ${media.mediumDown`
    grid-template-columns: 1fr;
    grid-template-rows: 1fr auto;
    row-gap: ${layout.measurements.spacing100};
  `}
`;

export const Main = styled.div`
  display: flex;
  flex-direction: column;

  > :not(:last-child) {
    margin-bottom: ${layout.measurements.spacing100};
  }
`;

export const ExpertList = styled.div(
  p => css`
    display: flex;
    justify-content: flex-end;

    ${media.mediumDown`
      overflow: hidden;
      margin-bottom: ${layout.measurements.spacing050};
    `};
  `
);

export const List = styled.div`
  display: grid;
  row-gap: ${layout.measurements.spacing100};
`;

export const ContentList = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  column-gap: ${layout.measurements.spacing100};

  ${media.mediumDown`
    grid-template-columns: repeat(5, minmax(250px, 1fr));
    overflow-x: auto;

    &::after {
      // Adds spacing to the end of the scroll area
      content: '';
      display: block;
      width: 1px;
      margin-left: -${layout.measurements.spacing100};
      pointer-events: none;
    }
  `};
`;

export const ContentCards = styled(ContentCardsComponent)`
  margin: 1px;

  a {
    color: ${p => p.theme.text.primary};
  }
`;

export const Description = styled.div`
  display: grid;
  row-gap: ${layout.measurements.spacing050};
  line-height: 1.5;
`;

const ListOfExpertWidth = '448px';

export const ListOfExperts = styled(ListOfExpertsComponent)`
  width: ${ListOfExpertWidth};
  justify-content: flex-end;

  ${media.mediumDown`
    width: 100%;
    overflow-x: scroll;
    grid-template-columns: unset;
    grid-auto-flow: column;
    justify-content: flex-start;
  `};
`;

export const ButtonDesktop = styled(Button)`
  ${media.largeUp`
    display: block;
  `}

  ${media.mediumDown`
      display: none;
  `};
`;

export const ButtonMobile = styled(Button)`
  ${media.largeUp`
    display: none;
  `}

  ${media.mediumDown`
      display: flex;
  `};

  ${media.smallOnly`
      width: 100%;

      > span {
        flex-grow: 0;
      }
  `};
`;
